import { z } from 'zod';
export const ETATS_INSTRUCTION = {
  RECEIVED: 'À instruire',
  PROPOSED: 'Avis à valider',
  VALIDATED: 'Avis validé',
} as const;
export const AVIS_INVESTISSEMENT = {
  FAVORABLE: 'Avis favorable',
  DEFAVORABLE: 'Avis défavorable',
  COMPLEMENTS: 'Compléments demandés',
} as const;
export const schemaActionInstruction = z
  .object({
    action: z.enum(['proposer', 'valider', 'retourner']),
    version: z.number().int().positive(),
    motif: z.string().trim().min(20).max(4000),
    avis: z.enum(['FAVORABLE', 'DEFAVORABLE', 'COMPLEMENTS']).optional(),
  })
  .strict()
  .superRefine((d, c) => {
    if ((d.action === 'proposer') !== (d.avis !== undefined))
      c.addIssue({
        code: 'custom',
        path: ['avis'],
        message: 'Un avis est requis uniquement pour une proposition',
      });
  });
